import React, {useState, useEffect} from "react";
import { useSearchParams } from "react-router-dom";
import "../../styles/base/Tab.css";
import DetailTab from "./NFTDetailTabs/DetailTab";
import ItemsTab from "./NFTDetailTabs/ItemsTab";
import NewExpTab from "./NFTDetailTabs/NewExpTab";
import { getABCollection } from "../../lib/artblocks";


const Tabs = ({item, getColors}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    
    // Initialize activeTab from URL parameter, default to "detail"
    const [activeTab, setActiveTab] = useState(searchParams.get('tab') || "detail");
    const [collectionDetail, setCollectionDetail] = useState({})
    
    // Update URL when tab changes
    const updateTab = (tabName) => {
        setActiveTab(tabName);
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('tab', tabName);
        setSearchParams(newSearchParams, { replace: true });
    };
    
    const handleDetailTab = () => {
        updateTab("detail");
    }
    const handleItemsTab = () => {
        updateTab("items");
    }
    const handleNewExpTab = () => {
        updateTab("newexp");
    }
    
    // Sync with URL parameter changes (e.g., browser back/forward)
    useEffect(() => {
        const tabFromUrl = searchParams.get('tab');
        if (tabFromUrl && ['detail', 'items', 'newexp'].includes(tabFromUrl)) {
            setActiveTab(tabFromUrl);
        }
    }, [searchParams]);
    
    useEffect(()=>{
        // Guard check: ensure item exists and has an id
        if (!item) {
            console.warn("[Tab] No item provided");
            return;
        }
        
        // Get or construct the collection ID
        // The ID format is: contractAddress-projectId
        let collectionId = item.id;
        if (!collectionId && item.contractAddress && item.projectId) {
            // Construct ID from contractAddress and projectId if id is missing
            collectionId = `${item.contractAddress.toLowerCase()}-${item.projectId}`;
        }
        
        if (!collectionId) {
            console.error("[Tab] Cannot determine collection ID from item:", item);
            // Use the item directly if we can't get an ID
            setCollectionDetail(item);
            return;
        }
        
        // Check localStorage first
        const cached = localStorage.getItem(collectionId);
        if(cached){
            try {
                const parsed = JSON.parse(cached);
                setCollectionDetail(parsed);
                return;
            } catch (e) {
                console.warn("[Tab] Failed to parse cached collection, fetching fresh:", e);
            }
        }
        
        // Fetch fresh data
        (async() => {
            try {
                console.log("[Tab] Fetching collection detail for:", collectionId);
                const collection = await getABCollection(collectionId);
                if (collection) {
                    localStorage.setItem(collectionId, JSON.stringify(collection));
                    setCollectionDetail(collection);
                } else {
                    console.warn("[Tab] getABCollection returned null, using item directly");
                    // Fallback: use the item we already have
                    setCollectionDetail(item);
                }
            } catch (error) {
                console.error("[Tab] Error fetching collection:", error);
                // Fallback: use the item we already have
                setCollectionDetail(item);
            }
        })();
    },[item])
    return (
        <div className="Tabs">
            <ul className="nav">
                <li className={activeTab === "detail" ? "active" : ""} onClick={handleDetailTab}>Collection Detail</li>
                <li className={activeTab === "items" ? "active" : ""} onClick={handleItemsTab}>All Items</li>
                <li className={activeTab === "newexp" ? "active" : ""} onClick={handleNewExpTab}>New Experience</li>
            </ul>
            <div className="outlet">
                {activeTab === "detail" && collectionDetail ? <DetailTab item={collectionDetail} getColors={getColors}/>  : <></>}
                {activeTab === "items" ? <ItemsTab item={collectionDetail}/> : <></>}
                {activeTab === "newexp" ? <NewExpTab item={collectionDetail}/> : <></>}
            </div>
        </div>
    );
};
export default Tabs;